import { UTILITYICONS } from "../assets/utility-icons";

export const utilityIcons = [
  { utility: "Water", icon: UTILITYICONS.WATERICON },
  { utility: "Hot water", icon: UTILITYICONS.FIREICON },
  { utility: "Trash", icon: UTILITYICONS.BINICON },
  { utility: "Sewer", icon: UTILITYICONS.FLOODICON },
];

export const utilityArray = ["Water", "Hot water", "Sewer", "Trash"];
